module.exports = __webpack_public_path__ + "img/line3.3e2f645d.png";